import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useTranslations } from "next-intl";
import styles from "./ContactUsCard.module.scss";
import EmailIcon from "@components/Icons/EmailIcon";
import AddressIcon from "@components/Icons/AddressIcon";
import FlexContainer from "@components/FlexContainer/FlexContainer";
import { Button } from "@components/Button/Button";
import fetcher from "@utils/Fetcher";
import { THEME_COLOR } from "@utils/Constants";

export const ContactUsCard = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const [isSending, setIsSending] = useState(false);
    const [successfullySent, setSuccessfullySent] = useState(false);

    const t = useTranslations("ContactUsPage");

    const handleChangeName = (event) => {
        setName(event.target.value);
    };

    const handleChangeEmail = (event) => {
        setEmail(event.target.value);
    };

    const handleChangeMessage = (event) => {
        setMessage(event.target.value);
    };

    const handleSendEmail = async (event) => {
        event.preventDefault();
        if (!name || !email || !message) {
            toast(t("please_fill_in_all_fields"));
            return;
        }
        setIsSending(true);

        try {
            await fetcher(
                "contact_us/send_email",
                "POST",
                JSON.stringify({
                    name,
                    email,
                    message,
                }),
            );
            setIsSending(false);
            setSuccessfullySent(true);

            const gtmEvent = {
                event: "conversion_event_submit_lead_form", // This is the 'Event' name GTM looks for
                form_name: "contact_us_form",
            };

            if (typeof window !== "undefined" && window.dataLayer) {
                window.dataLayer.push(gtmEvent);
            }
        } catch (e) {
            setIsSending(false);
            toast.error(
                `${t("error_msg1")}\n ${t("error_msg2")}\n ${t("error_msg3")}`,
            );
        }
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
            }}
        >
            <div className={styles.container}>
                <div className={styles.contactContainer}>
                    <h3>{t("contact_us")}</h3>
                    <div className={styles.contactItem}>
                        <AddressIcon style={{ height: 40, width: 40 }} />
                        <p>
                            Akralind 6,
                            <br />
                            201 Kópavogur
                        </p>
                    </div>
                    <a
                        href="mailto:laufid@laufid.is"
                        className={styles.contactItem}
                    >
                        <EmailIcon style={{ height: 40, width: 40 }} />

                        <p>laufid@laufid.is</p>
                    </a>
                </div>
                <form
                    className={styles.formContainer}
                    onSubmit={handleSendEmail}
                >
                    {successfullySent ? (
                        <FlexContainer
                            column
                            justifyContent="center"
                            alignItems="center"
                            className="text-center pt-3 pb-3"
                            style={{ minHeight: 467 }}
                        >
                            <img
                                className="success-icon"
                                style={{ width: 50, marginBottom: 20 }}
                                src={"/img/circled-checkmark.svg"}
                            />
                            <div>{t("thank_you_for_contacting_us")}</div>

                            <div>
                                {t("we_will_respond_earliest_opportunity")}
                            </div>
                        </FlexContainer>
                    ) : (
                        <>
                            <h4>{t("please_hear_us_out")}</h4>
                            <label htmlFor="name">{t("name")} *</label>
                            <input
                                type="text"
                                id="name"
                                value={name}
                                onChange={handleChangeName}
                            />
                            <label htmlFor="email">
                                {t("email_address")} *
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={handleChangeEmail}
                            />
                            <label htmlFor="message">{t("message")} *</label>
                            <textarea
                                id="message"
                                value={message}
                                onChange={handleChangeMessage}
                            />
                            <Button
                                style={{
                                    alignSelf: "end",
                                    background: isSending
                                        ? "#A4DDBC"
                                        : THEME_COLOR,
                                }}
                                disabled={isSending}
                            >
                                {t("send")}
                            </Button>
                        </>
                    )}
                </form>
            </div>
        </div>
    );
};
